import type { RushMidSnapshot, RushMidSpectateView } from '@cs-shot/battle-sim';
import { literalField } from '../lib/jsonBody';

const SNAPSHOT_STATUSES = ['NONE', 'PARTY', 'OPEN', 'BUYING', 'PLAYING', 'OVER'] as const;
const SPECTATE_STATUSES = ['PLAYING', 'OVER'] as const;

const isSnapshot = (raw: unknown): raw is RushMidSnapshot =>
  literalField(raw, 'status', SNAPSHOT_STATUSES) !== undefined;

const isSpectateView = (raw: unknown): raw is RushMidSpectateView =>
  literalField(raw, 'status', SPECTATE_STATUSES) !== undefined;

export function toDomainSnapshot(raw: unknown): RushMidSnapshot {
  return isSnapshot(raw) ? raw : { status: 'NONE' };
}

export function toSpectateView(raw: unknown): RushMidSpectateView | null {
  return isSpectateView(raw) ? raw : null;
}
